import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'DescribePositionUsingCoordinates',
      questionTypes: ['azk', 'azl', 'azm', 'azn', 'azo', 'azp'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/1DescribePositionUsingCoordinates" */ './1DescribePositionUsingCoordinatesModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'PlotCoordinates',
      questionTypes: ['azq', 'azr', 'azs', 'azt', 'azu', 'azv'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/2PlotCoordinates" */ './2PlotCoordinatesModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'Draw2DShapesOnAGrid',
      questionTypes: ['azw', 'azx', 'azy', 'azz', 'azA', 'azB'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/3Draw2DShapesOnAGrid" */ './3Draw2DShapesOnAGridModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'TranslateOnAGrid',
      questionTypes: ['azC', 'azD', 'azE', 'azF', 'azG', 'azH'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/4TranslateOnAGrid" */ './4TranslateOnAGridModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'DescribeTranslationOnAGrid',
      questionTypes: ['azI', 'azJ', 'azK', 'azL', 'azM', 'azN'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/5DescribeTranslationOnAGrid" */ './5DescribeTranslationOnAGridModels'
        )
    })
  ]
});
export default Block;
